import React, { useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@material-ui/core';
import {
  setSelectedRangeDate,
  setSelectedStartDate,
} from './../../redux/actions/newOperationHoursActions';
import { snackbarShowMessage } from './../../redux/actions/snackbarActions';
import SpecialEventsReasonsModal from './SpecialEventReasonsModal/SpecialEventsReasonsModal';

export default function OperationHoursFooter() {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();

  const {
    selectedStartDate,
    selectedEndDate,
    specialEventArrival,
    dtTimeOpenMode,
    dtTimeCloseMode,
    specialEventDeparture,
    cateringTimeOpenMode,
    cateringTimeCloseMode,
    cateringTimeOpen,
    cateringTimeClose,
    curbsideTimeOpenMode,
    curbsideTimeCloseMode,
    curbsideTimeOpen,
    curbsideTimeClose,
    isEditing,
    dtIsClosed,
    dtTimeOpen,
    dtTimeClose,
    drIsClosed,
    drTimeOpen,
    drTimeClose,
    dtIsOpened24Hours,
    drIsOpened24Hours,
    closeToAll
  } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  const restaurantServices = useSelector(
    (state: RootStateOrAny) => state.ServicesReducer.entities,
  );

  const brand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  const { RestaurantId, Region } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );
  const { selectedRestaurantsList: selectedRestaurants } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer,
  );

  const [confirmationModalOpen, setConfirmationModalOpen] =
    useState<boolean>(false);

  const confirmationModalOpenHandler = () => {
    const curbsideService = restaurantServices.find(elem => elem.code === "curbsidePickup");
    const cateringService = restaurantServices.find(elem => elem.code === "catering");
    const driveThruService = restaurantServices.find(elem => elem.code === "driveThru");
    if (!specialEventArrival && !closeToAll) {
      dispatch(
        snackbarShowMessage(
          t('operationHours.arrivalTimeMandatory'),
        ),
      );
      return;
    }

    if (!specialEventDeparture && !closeToAll && (brand === 'TH' && Region === 'NA')) {
      dispatch(
        snackbarShowMessage(
          t('operationHours.DepartureTimeMandatory'),
        ),
      );
      return;
    }

    if (!drTimeOpen && (drIsClosed === 'N' || !drIsClosed) && (drIsOpened24Hours === 'N' || !drIsOpened24Hours) || !drTimeClose && (drIsClosed === 'N' || !drIsClosed) && (drIsOpened24Hours === 'N' || !drIsOpened24Hours)) {
      dispatch(
        snackbarShowMessage(
          t('operationHours.diningRoomTimeMandatory'),
        ),
      );
      return;
    }
    if (driveThruService && driveThruService.value && RestaurantId){
      if (!dtTimeOpen && (dtIsClosed === 'N' || !dtIsClosed) && (dtIsOpened24Hours === 'N' || !dtIsOpened24Hours) || !dtTimeClose && (dtIsClosed === 'N' || !dtIsClosed) && (dtIsOpened24Hours === 'N' || !dtIsOpened24Hours)) {
        dispatch(
          snackbarShowMessage(
            t('operationHours.driveThruTimeMandatory'),
          ),
        );
        return;
      }
    }

    if (Array.isArray(cateringTimeOpenMode) &&
      Array.isArray(cateringTimeCloseMode) &&
      cateringTimeOpenMode.includes('write') &&
      cateringTimeCloseMode.includes('write')
    ) {

      if (cateringService && cateringService.value && RestaurantId &&
        !(cateringTimeOpen && cateringTimeClose) &&
        ((!closeToAll && brand === 'TH') || brand !== 'TH')) {
        dispatch(
          snackbarShowMessage(
            t('operationHours.cateringMandatory'),
          ),
        );
        return;
      }
    }

    if (Array.isArray(curbsideTimeOpenMode) &&
      Array.isArray(curbsideTimeCloseMode) &&
      curbsideTimeOpenMode.includes('write') &&
      curbsideTimeCloseMode.includes('write')
    ) {

      if (curbsideService && curbsideService.value && RestaurantId &&
        (!curbsideTimeOpen || !curbsideTimeClose) &&
        ((!closeToAll && brand === 'TH') || brand !== 'TH')) {
        dispatch(
          snackbarShowMessage(
            t('operationHours.curbsideMandatory'),
          ),
        );
        return;
      }

    }

    setConfirmationModalOpen(!confirmationModalOpen);
  };

  const clearForm = () => {
    if (selectedStartDate && selectedEndDate) {
      dispatch(setSelectedRangeDate(selectedStartDate, selectedEndDate));
    } else if (selectedStartDate) {
      dispatch(setSelectedStartDate(selectedStartDate));
    }
  };

  return (
    <Grid container direction="row" justify="flex-end" style={{ marginTop: 8 }}>
      <Grid item lg={2} xs={2} md={2} sm={2} xl={2}>
        <Button
          disabled={!isEditing}
          variant="contained"
          color="primary"
          style={{ marginRight: 10 }}
          onClick={clearForm}
        >
          {t('app.common.cancel')}
        </Button>
      </Grid>
      <Grid item lg={2} xs={2} md={2} sm={2} xl={2}>
        <Button
          disabled={!(isEditing && ((selectedRestaurants.length && !RestaurantId) || RestaurantId))}
          variant="contained"
          color="primary"
          onClick={confirmationModalOpenHandler}
        >
          {t('app.common.save')}
        </Button>
      </Grid>
      <SpecialEventsReasonsModal
        confirmationModalOpenHandler={confirmationModalOpenHandler}
        confirmationModalOpen={confirmationModalOpen}
      />
    </Grid>
  );
}
